import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export function categoryModel() {
  const getCategoryList = reactive({
    api: apiEndpoint.bcrm_platform + "/PrivilegeCategory/List",
    method: "POST",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
      Category_Level: 1,
      Type: 1,
    },
  });

  const getSubCategoryList = reactive({
    api: apiEndpoint.bcrm_platform + "/PrivilegeCategory/List",
    method: "POST",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
      Category_Level: 2,
      Category_Id: null,
      Type: 1,
    },
  });

  const getDetailCategory = reactive({
    api: apiEndpoint.bcrm_platform + "/PrivilegeCategory/Detail",
    method: "POST",
    xRequest: "",
    payload: {
      Category_Id: null,
    },
  });

  const createCategory = reactive({
    api: apiEndpoint.bcrm_platform + "/PrivilegeCategory/Create",
    method: "POST",
    xRequest: "",
    payload: {
      Category_Level: 1,
      Parent_Category_Id: null,
      Name_Th: "",
      Name_En: "",
      Desc_Th: "",
      Desc_En: "",
      Remark: "",
      Category_Image: null,
      Category_Sub_Image: null,
      Status: "",
      Req_Identity_Id: 1,
    },
  });

  const createSubCategory = reactive({
    api: apiEndpoint.bcrm_platform + "/PrivilegeCategory/Create",
    method: "POST",
    xRequest: "",
    payload: {
      Category_Level: 2,
      Parent_Category_Id: null,
      Name_Th: "",
      Name_En: "",
      Desc_Th: "",
      Desc_En: "",
      Remark: "",
      Category_Image: null,
      Category_Sub_Image: null,
      Status: "",
      Req_Identity_Id: 1,
    },
  });

  const EditSubCategory = reactive({
    api: apiEndpoint.bcrm_platform + "/PrivilegeCategory/Edit",
    method: "POST",
    xRequest: "",
    payload: {
      Category_Id: 1,
      Name_Th: "",
      Name_En: "",
      Desc_Th: "",
      Desc_En: "",
      Remark: "",
      Category_Image: null,
      Category_Sub_Image: null,
      Status: "",
      Req_Identity_Id: 1,
    },
  });

  const fetchReorderCategory = reactive({
    api: apiEndpoint.bcrm_platform + "/PrivilegeCategory/Reorder",
    method: "POST",
    xRequest: "",
    payload: {
      Category_Id: null,
      From: null,
      To: null,
    },
  });

  const fetchAssignCategory = reactive({
    api: apiEndpoint.bcrm_platform + "/PrivilegeCategory/Assign",
    method: "POST",
    xRequest: "",
    payload: {
      Category_Id: 0, //required
      Privilege_Id: 0, //required
      Req_Identity_Id: 1, //required
      IsPrimary: false, //required
    },
  });

  const fetchRemoveMappingCategory = reactive({
    api: apiEndpoint.bcrm_platform + "/PrivilegeCategory/Remove",
    method: "POST",
    xRequest: "",
    payload: {
      Category_Id: 0, //required
      Privilege_Id: 0, //required
      Req_Identity_Id: 1, //required
    },
  });

  const fetchDeleteCategory = reactive({
    api: apiEndpoint.bcrm_platform + "/PrivilegeCategory/Delete",
    method: "POST",
    xRequest: "",
    payload: {
      Category_Id: null,
      Req_Identity_Id: 1,
    },
  });

  return {
    getCategoryList,
    getDetailCategory,
    createCategory,
    getSubCategoryList,
    createSubCategory,
    EditSubCategory,
    fetchReorderCategory,
    fetchAssignCategory,
    fetchRemoveMappingCategory,
    fetchDeleteCategory
  };
}
